import { initLightbox } from './modules/lightbox';

function initYearFilter() {
  const yearSelects = document.querySelectorAll('.js-year-filter, #gallery-year-filter, #chronicle-year-filter');
  if (!yearSelects.length) {
    return;
  }

  yearSelects.forEach((select) => {
    select.addEventListener('change', (event) => {
      const targetUrl = event.target.value;
      if (targetUrl) {
        window.location.href = targetUrl;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initLightbox();
  initYearFilter();
});
